module.exports = __webpack_public_path__ + "img/bg-publish.94ded1ba.png";